import { AlertCircle, CheckCircle } from 'lucide-react';

export const ESTADO_CONFIG = {
  pendiente: { icon: AlertCircle, color: 'text-yellow-500', label: 'Pendiente' },
  tomada:   { icon: CheckCircle, color: 'text-green-500', label: 'Tomada' },
} as const;

export const ITEMS_PER_PAGE_PENDIENTES = 5;
export const ITEMS_PER_PAGE_LISTA = 10;
export const MIN_SEARCH_LENGTH = 4;
export const CATEGORIA_MICROBIOLOGIA = 'Microbiología';
export const VALOR_PLACEHOLDER = '0';
export const TEXTO_NO_DISPONIBLE = 'No disponible';
export const TEXTO_NO_ESPECIFICADA = 'No especificada';
export const TEXTO_NO_DISPONIBLE_GUION = '--';
export const METODOLOGIA_DEFAULT = 'Cultivo convencional';
export const PENDIENTE_ANALISIS = 'Pendiente de análisis';
export const RESULTADO_PENDIENTE = 'Resultado pendiente de procesamiento';
export const OBS_TOMADA = 'Muestra tomada - Pendiente de análisis microbiológico';
export const MAX_MUESTRAS_CARGA = 1000;
